var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 22.5C18.2132 22.5 23.25 17.4632 23.25 11.25C23.25 5.0368 18.2132 0 12 0C5.7868 0 0.75 5.0368 0.75 11.25C0.75 17.4632 5.7868 22.5 12 22.5ZM10.8068 11.25L8.02838 8.47162C7.69887 8.14212 7.69887 7.60788 8.02838 7.27838C8.35788 6.94887 8.89212 6.94887 9.22162 7.27838L12 10.0568L14.7784 7.27838C15.1079 6.94887 15.6421 6.94887 15.9716 7.27838C16.3011 7.60788 16.3011 8.14212 15.9716 8.47162L13.1932 11.25L15.9716 14.0284C16.3011 14.3579 16.3011 14.8921 15.9716 15.2216C15.6421 15.5511 15.1079 15.5511 14.7784 15.2216L12 12.4432L9.22162 15.2216C8.89212 15.5511 8.35788 15.5511 8.02838 15.2216C7.69887 14.8921 7.69887 14.3579 8.02838 14.0284L10.8068 11.25Z",
    fill: "#C1C5D6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.b2c72643dadfce5ea09395a90dea7273.svg";
export { ForwardRef as ReactComponent };